import { useState } from 'react';
import { Link } from 'react-router-dom';
import { trpc } from '@/trpc/client';

export function PromptsList(): JSX.Element {
  const [includeDeleted, setIncludeDeleted] = useState(false);
  const common = trpc.prompts.common.get.useQuery();
  const categories = trpc.prompts.category.list.useQuery({ includeDeleted });

  return (
    <div>
      <h1 className="mb-4 text-lg font-semibold">プロンプト管理</h1>
      <p className="mb-4 rounded bg-yellow-50 p-3 text-sm text-yellow-800">
        ⚠️ 編集内容は最大 60 秒で会話に反映されます
      </p>

      <section className="mb-6 rounded border border-gray-200 p-4">
        <h2 className="mb-2 text-base font-semibold">共通プロンプト</h2>
        <p className="text-sm text-gray-600">
          役割・口調・末尾ニュアンスなど。すべての応答に適用されます。
        </p>
        {common.data && (
          <p className="mt-2 text-xs text-gray-500">
            最終更新: {common.data.updatedAt} by {common.data.updatedBy?.email ?? '—'}
          </p>
        )}
        <Link to="/prompts/common" className="mt-2 inline-block text-blue-700 hover:underline">
          編集 →
        </Link>
      </section>

      <section>
        <div className="mb-2 flex items-center justify-between">
          <h2 className="text-base font-semibold">カテゴリプロンプト</h2>
          <Link to="/prompts/categories/new" className="text-blue-700 hover:underline">
            + 新規追加
          </Link>
        </div>
        <p className="mb-2 text-sm text-gray-600">
          ユーザー発言を AI が自動分類し、該当したカテゴリの応答生成プロンプトのみ追加で適用します
          (LINE への送信文ではありません)。
        </p>
        <label className="mb-3 inline-flex items-center gap-2 text-sm">
          <input
            type="checkbox"
            checked={includeDeleted}
            onChange={(e) => setIncludeDeleted(e.target.checked)}
          />
          削除済みも表示
        </label>
        <ul className="divide-y divide-gray-100">
          {categories.data?.map((c) => (
            <li key={c.id} className="py-3">
              <Link
                to={`/prompts/categories/${c.id}`}
                className="font-medium text-blue-700 hover:underline"
              >
                {c.displayName}
              </Link>
              <span
                className={`ml-2 inline-block rounded px-2 py-0.5 text-xs ${
                  c.kind === 'optout' ? 'bg-red-100 text-red-800' : 'bg-gray-100 text-gray-700'
                }`}
              >
                {c.kind === 'optout' ? '案内停止' : '通常'}
              </span>
              <p className="text-sm text-gray-600">{c.classifierHint}</p>
              <p className="text-xs text-gray-500">
                最終更新: {c.updatedAt} by {c.updatedBy?.email ?? '—'}
              </p>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}
